import styles from '@/styles/global/bread-crumb.module.scss'
import { Arrow } from '@/utils/react-vant'
import type { BreadCrumbItem } from '@/types/product'

interface Props {
  BreadList: BreadCrumbItem[] | []
}

export default function BreadCrumb({ BreadList } : Props) {
  return (
    <div className={styles['comp-breadcrum-box']}>
      {
        !!(BreadList && BreadList.length) &&
        <>
          {
            BreadList.map((item: BreadCrumbItem, index: number) => (
              <div key={index} className={styles['breadcrum-item-box']}>
                <a 
                  href={item.url} 
                  className={`${styles['breadcrum-item']} ${ item.current && styles['active-item'] }`} 
                  rel="noopener noreferrer"
                >
                  {item.name}
                </a>
                {index < BreadList.length - 1 && (
                  <Arrow className={styles['breadcrum-separator']}></Arrow>
                )}
              </div>
            ))
          }
        </>
      }
    </div>
  )
}
